import React from 'react';
import { useDispatch } from 'react-redux';
import { createStore } from 'jotai';
// TODO: generalize noc drilldown in to a common trends drilldown
import { initDrilldown } from '@store/trends/tempDashboard/nocDrilldown/actions';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import { dimensionPanelAtom, metricPanelAtom, summaryPanelAtom } from '@src/atoms/panels';
import { aiAlertAtom, manualAlertAtom } from '@src/atoms/toggles';
import {
  diagnosticsModeAtom,
  dodAtom,
  layoutAtom,
  logAxisAtom,
  percentileAtom,
  primaryFilterVisibilityAtom,
  sliceAreaAtom,
  unitAtom,
  widgetPanelVisibilityAtom,
  yScaleModeAtom,
  zoomAreaAtom,
} from '@components/metrics-panel-hz/atoms';
import Main from './Main';
import AppMain from '../AppExperience/index';
import TempDashboardHoc from './TempDashboardHoc';
import { isTableCompareEnabledAtom } from '@src/components/dimension-panel-hz/atoms/index';
import { useCaseKeyAtom } from '@src/atoms/pageMeta';

const RenderPage = {
  EI: Main,
  AI: Main,
  APP: AppMain,
}[CURRENT_PRODUCT_MODE];

//TODO: combine with initTrendsBasedStore
function initStore({ dashboard: state = {} }) {
  const store = createStore();

  if ('metricPanel' in state) {
    const {
      unit = '%',
      sliceArea = null,
      zoomArea = null,
      diagnosticsMode = false,
      logAxis = false,
      primaryFilterVisibility = true,
      layout = '4s',
      widgetPanelVisibility = false,
      percentile = 'avg',
      yScaleMode = false,
    }: any = state.metricPanel;
    store.set(layoutAtom, layout);
    store.set(unitAtom, unit);
    store.set(percentileAtom, percentile);
    store.set(yScaleModeAtom, yScaleMode);
    store.set(sliceAreaAtom, sliceArea);
    store.set(zoomAreaAtom, zoomArea);
    store.set(diagnosticsModeAtom, diagnosticsMode);
    store.set(logAxisAtom, logAxis);
    store.set(primaryFilterVisibilityAtom, primaryFilterVisibility);
    store.set(widgetPanelVisibilityAtom, widgetPanelVisibility);
  }

  if ('toggles' in state) {
    const { sections, diagnostics } = state.toggles;
    if (sections) {
      const { summary = true, metric = true, dimension = true } = sections;
      store.set(summaryPanelAtom, summary);
      store.set(metricPanelAtom, metric);
      store.set(dimensionPanelAtom, dimension);
    }

    if (diagnostics) {
      const { manualAlert = false, aiAlert = false, dod = false } = diagnostics;
      store.set(manualAlertAtom, manualAlert);
      store.set(aiAlertAtom, aiAlert);
      store.set(dodAtom, dod);
    }
  }

  if ('isTableCompareEnabled' in state) {
    const { isTableCompareEnabled = false }: any = state;
    store.set(isTableCompareEnabledAtom, isTableCompareEnabled);
  }

  if ('usecaseKey' in state && !!state.usecaseKey) {
    store.set(useCaseKeyAtom, state.usecaseKey);
  }

  return store;
}

function DrilldownDashboard(props) {
  const dispatch = useDispatch();

  const applyCallback = (payload, doneCallback) => {
    dispatch(initDrilldown(payload.dashboard));
    doneCallback();
  };

  return (
    <TempDashboardHoc {...props} applyCallback={applyCallback} initStore={initStore}>
      {({ store, title }) => <RenderPage {...props} store={store} title={title} />}
    </TempDashboardHoc>
  );
}

export default DrilldownDashboard;
